export const ALL_ROUTES_GROUP_LABEL = "__all_routes__";
